export const home = {
  // Hero Section
  title: 'MakanTak',
  tagline: 'Peroleh ganjaran dengan berkongsi. Jimat setiap kali makan.',
  subtitle: 'Platform diskaun restoran yang viral.',
  getStarted: 'Sertai sekarang',
  login: 'Log Masuk',
  demo: 'Demo',
  
  // Features
  feature1Title: 'Diskaun Terjamin 5%',
  feature1Desc: 'Dapatkan diskaun 5% serta-merta pada lawatan pertama anda di mana-mana restoran yang mengambil bahagian. Tiada syarat tersembunyi.',
  feature1Badge: 'Bonus lawatan pertama',
  
  feature2Title: 'Kongsi & Peroleh',
  feature2Desc: 'Kongsi kod unik anda dengan rakan. Peroleh 1% daripada bil mereka sebagai mata wang virtual setiap kali mereka makan.',
  feature2Badge: 'Sistem ganjaran 3 peringkat',
  
  feature3Title: 'Tebus Ganjaran',
  feature3Desc: 'Gunakan mata wang virtual yang anda peroleh untuk membayar hidangan anda. Tebus sehingga 20% daripada bil anda.',
  feature3Badge: 'Maksimum 20% penebusan',
  
  // Merchant CTA
  merchantTitle: 'Memiliki Restoran?',
  merchantSubtitle: 'Sertai MakanTak dan jadikan pelanggan anda sebagai duta jenama. Bayar hanya untuk hasil dengan sistem rujukan viral kami.',
  merchantPoint1: 'Kos pemasaran maksimum 8% - bayar hanya apabila pelanggan makan',
  merchantPoint2: 'Bina rangkaian rujukan pelanggan anda sendiri',
  merchantPoint3: 'Jejak ROI dengan papan pemuka analitik masa nyata',
  merchantCTA: 'Rakan kongsi kami',
  
  // About Section
  aboutTitle: 'Mengapa MakanTak?',
  aboutSubtitle: 'Kami merevolusikan cara restoran Malaysia mengembangkan perniagaan mereka melalui pemasaran dari mulut ke mulut yang viral.',
  
  aboutCard1Title: 'Didorong Komuniti',
  aboutCard1Desc: 'Dibina untuk restoran tempatan Malaysia dan pelanggan setia mereka. Kami percaya dalam berkembang bersama melalui rujukan tulen.',
  
  aboutCard2Title: 'Berasaskan Prestasi',
  aboutCard2Desc: 'Tiada kos pendahuluan. Restoran hanya membayar apabila pelanggan benar-benar makan. Telus, boleh diukur, dan adil untuk semua orang.',
  
  aboutCard3Title: 'Selamat & Patuh',
  aboutCard3Desc: 'Mematuhi PDPA dengan langkah keselamatan yang kukuh. Data anda dilindungi, dan privasi anda adalah keutamaan kami.',
  
  // Footer
  footerTagline: 'Kongsi penjimatan, kembangkan komuniti.',
  footerDesc: 'Platform diskaun restoran viral untuk restoran tempatan Malaysia.',
  forCustomers: 'Untuk Pelanggan',
  forRestaurants: 'Untuk Restoran',
  company: 'Syarikat',
  demoLink: 'Papan Pemuka Demo',
  faqLink: 'Soalan Lazim',
  merchantEnquiry: 'Pertanyaan Pedagang',
  aboutUs: 'Tentang Kami',
  contact: 'Hubungi',
  privacy: 'Dasar Privasi',
  terms: 'Terma Perkhidmatan',
  copyright: '© 2026 MakanTak. Hak cipta terpelihara.',
  followUs: 'Ikuti kami di X',
};
